import { Dispatch, SetStateAction } from 'react';
import ReactModal from 'react-modal';
import ReactPlayer from 'react-player';
import styled from 'styled-components';
import { ReCAPTCHAProvider } from 'contexts/ReCAPTCHAContext';
import { Pool } from 'templates/pool/types';
import { IoMdCloseCircle } from 'react-icons/io';

interface IModalProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  pool?: Pool;
}
export function ModalPoolVideo({ open, setOpen, pool }: IModalProps) {
  const customStyles: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      height: '100%',
      transform: 'translate(-50%, -50%)',
      minWidth: '310px',
      maxWidth: '758px',
      maxHeight: '650px',
      padding: 0,
    },
    overlay: {
      zIndex: 999,
      backgroundColor: 'rgba(0,0,0,0.5)',
    },
  };

  return (
    <ReCAPTCHAProvider>
      <ReactModal isOpen={open} style={customStyles} onRequestClose={() => setOpen(false)}>
        <Container bgColor={pool?.backgroundColor}>
          <div>
            <div>
              <span>{pool?.title}</span>
              <span onClick={() => setOpen(false)}>
                <IoMdCloseCircle />
              </span>
            </div>
          </div>
          <ReactPlayer
            style={{
              borderRadius: 10,
            }}
            url={pool?.videoUrl}
            onEnded={() => setOpen(false)}
            controls={true}
            autoplay={true}
            playing={true}
            width={'100%'}
            height={'100%'}
          />
        </Container>
      </ReactModal>
    </ReCAPTCHAProvider>
  );
}

const Container = styled.div<{ bgColor?: string }>`
  width: 620px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 !important;
  background-color: #fff;
  gap: 8px;

  & > div {
    &:first-child {
      display: flex;
      align-items: center;
      padding: 0.5rem;

      & div {
        display: flex;
        padding: 0.5rem;
        font-size: 14pt;
        width: 100%;
        border-radius: 4px;
        align-items: center;

        & span {
          &:first-child {
            flex: 1;
            color: ${({ bgColor }) => bgColor ?? '#174f68'};
            font-weight: bold;
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;
